import { ResourcesConfig } from 'aws-amplify';

const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_2vzLROBtV',
      userPoolClientId: '2agi73cptq37s4vl3jaetenufu',
      signUpVerificationMethod: 'code' as const
    }
  },
  API: {
    REST: {
      reviewReplyApi: {
        endpoint: 'https://j4l1m2rky3.execute-api.us-east-1.amazonaws.com/prod/',
        region: 'us-east-1'
      }
    }
  }
};

export default amplifyConfig;

